<template>
  <NuxtLink to="/" class="logo" aria-label="Robotics Vision — на главную">
    <SiteBrandMark :size="40" class="logo-mark" /><span>Robotics Vision</span>
  </NuxtLink>
</template>
